var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "f28070fab37a81c48d0f187530251425ef5881ed"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["icloudready-newwebsite@icloudready"] = {
  id: "f28070fab37a81c48d0f187530251425ef5881ed"
};